var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_core.js
// module id = 600
// module chunks = 1